var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThunderOrange = function SvgThunderOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff766f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa6b63"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_20473",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(-972.93 -458.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 972.93, 458.51)",
    filter: "url(#Path_20473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_20473-2",
    "data-name": "Path 20473",
    transform: "translate(3 2)",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 19.5 C 4.761680126190186 19.5 0.5 15.23832035064697 0.5 10 C 0.5 4.761680126190186 4.761680126190186 0.5 10 0.5 C 15.23832035064697 0.5 19.5 4.761680126190186 19.5 10 C 19.5 15.23832035064697 15.23832035064697 19.5 10 19.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 C 1 14.96261978149414 5.037380218505859 19 10 19 C 14.96261978149414 19 19 14.96261978149414 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#ff6057"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_728951_electricity_lightning_charge_electric_forecast_icon",
    "data-name": "728951_electricity_lightning_charge_electric_forecast_icon",
    d: "M26.364,4.125H25.008l1.886-3.056a.735.735,0,0,0,.032-.706A.632.632,0,0,0,26.364,0H23.183a.629.629,0,0,0-.552.346L20.085,5.159a.735.735,0,0,0,0,.686.628.628,0,0,0,.55.342h2.085l-2,3.784a.725.725,0,0,0,.166.888.6.6,0,0,0,.386.141.611.611,0,0,0,.45-.2l5.091-5.5a.728.728,0,0,0,.138-.749A.639.639,0,0,0,26.364,4.125Z",
    transform: "translate(962.429 465.011)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThunderOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thunderOrange.3a38032b.svg";
export { ForwardRef as ReactComponent };